var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightLong = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 46 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A4ADB4",
  d: "m45.5 3-5-2.887v5.774zm-45 .5H41v-1H.5z"
})));
export default SvgArrowRightLong;